import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Viewers from './index';

function ModalViewer({ open, onClose, title, fileType, fileUrl }) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'fixed',
          top: '0.5vw',
          left: '1vw',
          width: '98vw',
          height: '97vh',
          bgcolor: 'background.paper',
          outline: 'none',
          display: 'flex',
          flexDirection: 'column',
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            pl: 1,
            borderBottom: 1,
            borderColor: 'divider',
          }}>
          <Typography fontWeight="bold" variant="body1">
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
          <Viewers file={fileUrl} fileType={fileType} />
        </Box>
      </Box>
    </Modal>
  );
}

export default ModalViewer;
